import { render } from "./CategoryGrid.vue?vue&type=template&id=95dcb79c&scoped=true"
import script from "./CategoryGrid.vue?vue&type=script&lang=js"
export * from "./CategoryGrid.vue?vue&type=script&lang=js"

import "./CategoryGrid.vue?vue&type=style&index=0&id=95dcb79c&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95dcb79c"]])

export default __exports__